// DcInfoView.js
// import React, {useEffect, useState, useRef} from 'react';
import { styled  } from '@mui/material/styles';
import { Box } from '@mui/system';
import {
    DialogContent, DialogActions, Button,
} from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';
import EditIcon from '@mui/icons-material/Edit';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import { VzmInputBlock, VzmLabel, VzmDataText } from '../../common/VzmStyled';
import DraggableViewer from '../../common/DraggableViewer';
import { AppStyle, AppWord } from '../../value/AppConst';
import { useReactiveVar } from '@apollo/client';
import { authTableTreeRepo } from '../../value/AppModel';
import { DcInfoDictionary } from './DcInfoDict';
import { useAuthorizationCheck } from '../../api/app-hook';

// background color in gradient style (light gray to white, then light gray)
const ViewContainer = styled(Box)({
    marginTop: 10, display: 'flex',
});

const ViewColumn = styled(Box)({flexGrow:1, padding: 10,});

const InputMap = DcInfoDictionary.inputMap;

/**
 * 물류센터(DC_INFO) 정보 상세보기
 * Using React with MUI5
 * Project: NewTOP for cloud
 * 2024-08-26 15:58:03 using DbdbTap
 */
export default function DcInfoView({
    open,
    item,
    onRequestEdit,
    onClose
}) {
    const authTableTree = useReactiveVar(authTableTreeRepo);
    const checkAuth = useAuthorizationCheck();

    if(!open || !item) return null;

    const canEdit = checkAuth(authTableTree.tree.pr_dc_info_edit);
    return(
        <DraggableViewer open={open} onClose={onClose} maxWidth='lg'
            title={
                <>
                <MenuBookIcon fontSize={AppWord.LARGE} style={{color:'white', marginRight:15}}/>
                {item.dcName} ({item.dcTypeName})
                </>
            }
        >
            <DialogContent>
                <ViewContainer>
                    <ViewColumn>
                        <VzmInputBlock>
                            <VzmLabel>{InputMap.dcTypeCd.label}</VzmLabel>
                            <VzmDataText>{item.dcTypeName}</VzmDataText>
                        </VzmInputBlock>
                        <VzmInputBlock>
                            <VzmLabel>{InputMap.dcCd.label}</VzmLabel>
                            <VzmDataText>{item.dcCd}</VzmDataText>
                        </VzmInputBlock>
                        <VzmInputBlock>
                            <VzmLabel>사용구분</VzmLabel>
                            <VzmDataText>{item.useYn==='Y'?'사용':'사용중지'}</VzmDataText>
                        </VzmInputBlock>
                        <VzmInputBlock>
                            <VzmLabel>{InputMap.docknoStart.label}</VzmLabel>
                            <VzmDataText>{item.docknoStart}</VzmDataText>
                        </VzmInputBlock>
                        <VzmInputBlock>
                            <VzmLabel>{InputMap.docknoEnd.label}</VzmLabel>
                            <VzmDataText>{item.docknoEnd}</VzmDataText>
                        </VzmInputBlock>
                        <VzmInputBlock>
                            <VzmLabel>{InputMap.pierTimeIntervalCd.label}</VzmLabel>
                            <VzmDataText>{item.pierTimeInterval}</VzmDataText>
                        </VzmInputBlock>
                        <VzmInputBlock>
                            <VzmLabel>{InputMap.tempFore.label}</VzmLabel>
                            <VzmDataText>{item.tempFore}</VzmDataText>
                        </VzmInputBlock>
                        <VzmInputBlock>
                            <VzmLabel>{InputMap.tempMid.label}</VzmLabel>
                            <VzmDataText>{item.tempMid}</VzmDataText>
                        </VzmInputBlock>
                        <VzmInputBlock>
                            <VzmLabel>{InputMap.tempRear.label}</VzmLabel>
                            <VzmDataText>{item.tempRear}</VzmDataText>
                        </VzmInputBlock>
                        <VzmInputBlock>
                            <VzmLabel>{InputMap.useTransType.label}</VzmLabel>
                            <VzmDataText>{
                                item.useTransType ? InputMap.useTransType.select.true : InputMap.useTransType.select.false
                                }
                            </VzmDataText>
                        </VzmInputBlock>
                    </ViewColumn>
                    <ViewColumn>
                        <VzmInputBlock>
                            <VzmLabel>{InputMap.zipCd.label}</VzmLabel>
                            <VzmDataText>{item.zipCd}</VzmDataText>
                        </VzmInputBlock>
                        <VzmInputBlock>
                            <VzmLabel>{InputMap.addr.label}</VzmLabel>
                            <VzmDataText>{item.addr}</VzmDataText>
                        </VzmInputBlock>
                        <VzmInputBlock>
                            <VzmLabel>{InputMap.officeTelno.label}</VzmLabel>
                            <VzmDataText>{item.officeTelno}</VzmDataText>
                        </VzmInputBlock>
                        <VzmInputBlock>
                            <VzmLabel>{InputMap.officeStaffName.label}</VzmLabel>
                            <VzmDataText>{item.officeStaffName}</VzmDataText>
                        </VzmInputBlock>
                        <VzmInputBlock>
                            <VzmLabel>{InputMap.secuTelno.label}</VzmLabel>
                            <VzmDataText>{item.secuTelno}</VzmDataText>
                        </VzmInputBlock>
                        <VzmInputBlock>
                            <VzmLabel>{InputMap.secuStaffName.label}</VzmLabel>
                            <VzmDataText>{item.secuStaffName}</VzmDataText>
                        </VzmInputBlock>
                        <VzmInputBlock>
                            <VzmLabel>{InputMap.transStaffName.label}</VzmLabel>
                            <VzmDataText>{item.transStaffName}</VzmDataText>
                        </VzmInputBlock>
                        <VzmInputBlock>
                            <VzmLabel>{InputMap.operStaffName.label}</VzmLabel>
                            <VzmDataText>{item.operStaffName}</VzmDataText>
                        </VzmInputBlock>
                    </ViewColumn>
                </ViewContainer>
            </DialogContent>
            <DialogActions>
                {
                    canEdit ?
                    <Button
                        onClick={()=>{onRequestEdit(item)}}
                        variant={AppStyle.mui.contained}
                        color={AppStyle.mui.inherit}
                        sx={{width: 120, marginRight: 1}}
                        startIcon={<EditIcon />}
                    >
                        편집
                    </Button>
                    : null
                }
                <Button onClick={onClose}
                    variant={AppStyle.mui.contained}
                    color={AppStyle.mui.primary}
                    sx={{width: 120}}
                    startIcon={<DoneIcon />}
                >
                    닫기
                </Button>
            </DialogActions>
        </DraggableViewer>
    );

}